<template>
  <footer>
    <div>Copyright &copy; {{currentYear}} Guerrilla Dimension</div>
    <div>"Guerrilla Dimension meets all of my DDoS needs and more." ~Jane Goodall</div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../assets/styles/colors';
@import '../assets/styles/mixin';

footer {
  @include flex(column, center, space-between);
  max-width: 1024px;
  margin: 36px auto;
  padding: 0 8px;

  @media (min-width: 768px) {
    @include flex(row, space-between, center);
  }

  @media (min-width: 1024px) {
    padding: 0;
  }

  div {
    font-size: 12px;
    color: $gd-dark-gray;
    padding: 8px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue